module.exports = __webpack_public_path__ + "static/media/23_tn.0aba416a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/23_tn.jpg
// module id = 659
// module chunks = 0